import { HTTP } from '@/services/axios'

/**
 * Fetch the current user's profile settings.
 *
 * @returns {Promise<{ id: number; user: number; timezone: string }>} The profile settings object.
 */
export const fetchProfileSettings = async () => {
  const response = await HTTP.get('profile-settings/')

  return response.data
}

/**
 * Update the current user's profile settings.
 *
 * @param   {{ timezone: string }}                                    payload - The settings to update.
 * @returns {Promise<{ id: number; user: number; timezone: string }>}         The updated profile settings object.
 */
export const updateProfileSettings = async payload => {
  const response = await HTTP.patch('profile-settings/', payload)

  return response.data
}

const profileAPI = {
  fetchProfileSettings,
  updateProfileSettings
}

export default profileAPI
